import { v4 as uuidv4 } from "uuid";
import { formatTimestamp } from "../utils/utils";
import { MessageType } from "../types/chat.type";
import { ChatbotDesignDTO, ThemeConfig } from "../types/theme.type";

/**
 * 初期メッセージ
 */
export const DEFAULT_WELCOME_MESSAGE: MessageType = {
  id: uuidv4(),
  text: `いらしゃいませ、AIチャットロボットです。\nどうぞ、ご質問をお願いします。\nお客様のご質問にお答えいたします。`,
  sent: false,
  timestamp: formatTimestamp(new Date()),
  avatar: "AI",
  isRobot: true,
  shouldDisplayFeedback: false,
  feedback: "--",
  referLinks: [],
};

/**
 * デフォルトテーマ設定
 */
export const DEFAULT_DESIGN: ChatbotDesignDTO = {
  alignment: "right",
  banner_margin_horizontal: 20,
  banner_margin_vertical: 20,
  chat_margin_horizontal: 20,
  chat_margin_vertical: 20,
  chat_display_width: 400,
  chat_display_height: 600,
  header_background_color: "#4641A3",
  header_text_color: "#FFFFFF",
  header_font_size: 16,
  date_background_color: "#777777",
  date_text_color: "#FFFFFF",
  main_background_color: "#FFFFFF",
  main_text_color: "#2e1c1c",
  bot_bubble_border_color: "#4641A3",
  bot_bubble_background_color: "transparent",
  bot_bubble_text_color: "#000000",
  bot_bubble_font_size: 14,
  bot_bubble_link_color: "#1976d2",
  user_bubble_border_color: "#E8E8F4",
  user_bubble_background_color: "#E8E8F4",
  user_bubble_text_color: "#2e1c1c",
  user_bubble_font_size: 14,
  resolved_button_border_color: "#4641A3",
  resolved_button_background_color: "#4641A3",
  resolved_button_text_color: "#FFFFFF",
  resolved_button_hover_background_color: "#383482",
  resolved_button_label: "解決した",
  unresolved_button_border_color: "#4641A3",
  unresolved_button_background_color: "transparent",
  unresolved_button_text_color: "#2e1c1c",
  unresolved_button_hover_background_color: "#E8E8F4",
  unresolved_button_label: "解決しなかった",
  flow_choice_border_color: "#4641A3",
  flow_choice_background_color: "#FFFFFF",
  flow_choice_text_color: "#4641A3",
  flow_choice_hover_background_color: "#E8E8F4",
  footer_background_color: "#FFFFFF",
  input_field_border_color: "#eeeeee",
  input_field_background_color: "#FFFFFF",
  input_field_text_color: "#2e1c1c",
  input_field_font_size: 14,
  input_field_placeholder: "ここに質問を入力",
  input_field_placeholder_text_color: "#999999",
  send_button_disabled_color: "#CCCCCC",
  send_button_enabled_color: "#4641A3",
  version: 1,
};

/**
 * デフォルト設定
 */
export const DEFAULT_CONFIG: ThemeConfig = {
  // 画像
  botAvatar:
    "https://pathbee-dev.s3.ap-northeast-1.amazonaws.com/public/chatbots/default/icon.svg",
  // ユーザーアイコンはまだ使ってない、将来のために残しておく
  userAvatar: "",
  buttonInitIcon:
    "https://pathbee-dev.s3.ap-northeast-1.amazonaws.com/public/chatbots/default/banner.svg",
  bannerWidth: 0,
  bannerMWidth: 0,
  isBannerM: false,
  bannerMUrl: "",
  buttonSendIcon:
    "https://pathbee-dev.s3.ap-northeast-1.amazonaws.com/public/chatbots/default/kami_plane_icon.svg",

  // テキスト
  chatbotTitle: "AIアシスタント パスビーさん",
  chatbotName: "パスビーさん",

  // メッセージ
  greetingMsg: "こんにちは！AIアシスタントパスビーでございます",
  resolvedMsg: "お役に立てて光栄です！",
  unresolvedMsg:
    "申し訳ございません。\nお手数ですが、お問い合わせフォームからお問い合わせ頂くか、以下の電話番号からお問い合わせください。\n0120-161-860",
};
